import axios from '@/plugins/axios'
import { getAccountId } from '@/helper/auth-helper'

const getNotifications = () => axios.get(`${getAccountId()}/notifications`)
const getNotificationsCounter = () => axios.get(`${getAccountId()}/notifications/count`)

export { getNotifications, getNotificationsCounter }
